import * as t from "@babel/types";
function oneRouterMetroPlugin(_, options) {
  function isFirstInAssign(path) {
    return t.isAssignmentExpression(path.parent) && path.parent.left === path.node;
  }
  var { ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY, ONE_ROUTER_LINKING_CONFIG, ONE_ROUTER_ROOT_FOLDER_NAME, ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING, ONE_SETUP_FILE_NATIVE } = options;
  if (!ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY`);
  }
  if (!ONE_ROUTER_ROOT_FOLDER_NAME) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_ROOT_FOLDER_NAME`);
  }
  if (!ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING`);
  }
  return {
    name: "one-router-metro",
    visitor: {
      Program(path, state) {
        var _state_filename;
        if (ONE_SETUP_FILE_NATIVE && ((_state_filename = state.filename) === null || _state_filename === void 0 ? void 0 : _state_filename.endsWith("metro-entry.js"))) {
          var importDeclaration = t.importDeclaration([], t.stringLiteral(ONE_SETUP_FILE_NATIVE));
          var body = path.get("body");
          var lastImportIndex = -1;
          for (var i = 0; i < body.length; i++) {
            if (body[i].isImportDeclaration()) {
              lastImportIndex = i;
            }
          }
          if (lastImportIndex >= 0) {
            body[lastImportIndex].insertAfter(importDeclaration);
          } else {
            path.unshiftContainer("body", importDeclaration);
          }
        }
      },
      MemberExpression(path, state) {
        if (path.get("object").matchesPattern("process.env")) {
          var key = path.toComputedKey();
          if (t.isStringLiteral(key) && !isFirstInAssign(path)) {
            if (key.value.startsWith("ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY")) {
              path.replaceWith(t.stringLiteral(ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY));
            } else if (key.value.startsWith("ONE_ROUTER_ROOT_FOLDER_NAME")) {
              path.replaceWith(t.stringLiteral(ONE_ROUTER_ROOT_FOLDER_NAME));
            } else if (key.value === "ONE_ROUTER_LINKING_CONFIG") {
              var _state_filename;
              if ((_state_filename = state.filename) === null || _state_filename === void 0 ? void 0 : _state_filename.endsWith("metro-entry.js")) {
                path.replaceWith(t.valueToNode(ONE_ROUTER_LINKING_CONFIG));
              }
            } else if (key.value.startsWith("ONE_ROUTER_REQUIRE_CONTEXT_REGEX")) {
              path.replaceWith(t.regExpLiteral(ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING));
            } else if (key.value === "ONE_SETUP_FILE_NATIVE") {
              path.replaceWith(ONE_SETUP_FILE_NATIVE ? t.stringLiteral(ONE_SETUP_FILE_NATIVE) : t.identifier("undefined"));
            }
          }
        }
      }
    }
  };
}
var one_router_metro_default = oneRouterMetroPlugin;
export {
  one_router_metro_default as default
};
//# sourceMappingURL=one-router-metro.js.map
